<template>
  <div id="register">
    <Header />
    <div id="register__step">
      <div class="line"></div>
      <div class="current_line" :style="`width: calc(${registerIndex * 33.33}% - 40px)`"></div>
      <div class="step" v-for="(s, i) in step" :class="{'active': i <= registerIndex - 1}" :key="i">
        <div class="num"><i :class="`icon-${s.id}`"></i></div>
        <div class="text">{{ s.text }}</div>
      </div>
    </div>

    <section id="register__content">
      <BlockTitle title="会员注册" />

      <!-- register -->
      <template v-if="registerStep === 'register'">
        <div id="register__byEmail">
          <label for="user_account_id" :class="{'invalid': isInValidAccountId || registerError}">
            <div class="label_title">
              帐号
              <span>*{{
                registerError
                  ? registerError
                  : isInValidAccountId
                  ? '只能包含字母、数字、英文句号「.」和底线「_」，且不可少于4个字'
                  : '请输入英数，且不可少于4个字'  }}</span>
            </div>
            <input ref="account_id" type="email" for="user_account_id" v-model="account_id">
          </label>
          <div class="desc">建议使用可以记住的帐号，例如：QQ号</div>
          <div class="btns">
            <div class="btn register" @click="handleEmailSubmit">注册</div>
          </div>
        </div>
      </template>

      <template v-if="registerStep === 'info'">
        <div id="register__info" :class="{'goOut': registerIndex === 3}">
          <label for="your_email">
            <div class="label_title">
              帐号
            </div>
            <div class="your_email">{{ account_id }}</div>
          </label>

          <label for="your_nickname" :class="{'invalid': isInValidNickName || (registerError && registerError.username) || loginUsernameError}">
            <div class="label_title">
              暱称
              <span>*{{ loginUsernameError ? loginUsernameError : '最多6个字' }}</span>
            </div>
            <input type="text" id="your_nickname" v-model="nickname" @blur="blurUsername">
          </label>

          <label for="your_birthday" :class="{'invalid': isInValidBirthday }">
            <div class="label_title">
              生日
              <span>*(1990/01/01)</span>
            </div>

            <div class="label_birthday">
              <input type="number" max="2990" min="1990" v-model="birthday_year" @focus="clearBirthdayYearValue">
              <input type="number" max="12" min="1" v-model="birthday_month" @focus="clearBirthdayMonthValue">
              <input type="number" max="31" min="1" v-model="birthday_day" @focus="clearBirthdayDayValue">
            </div>

            <div class="desc">生日资料将用于「忘记密码」找回使用，注册后不可修改</div>
          </label>

          <label for="your_password" :class="{'invalid': isInValidPassword || (registerError && registerError.password)}">
            <div class="label_title">
              密码
              <span>*6~12个字，需英數混合</span>
            </div>
            <div class="label_input">
              <input
                id="your_password"
                :type="passwordType"
                v-model="password">
              <div class="eye" @click="handleSeePassword('password')">
                <i :class="`icon-eye_${eyePasswordType}`"></i>
              </div>
            </div>
          </label>

          <label for="your_check_password" :class="{'invalid': isInValidCheckPassword}">
            <div class="label_title">
              再次确认密码
              <span>*請與密碼相同</span>
            </div>
            <div class="label_input">
              <input
                id="your_check_password"
                :type="passwordCheckType"
                v-model="checkPassword">
              <div class="eye" @click="handleSeePassword('checkpassword')">
                <i :class="`icon-eye_${eyeCheckPasswordType}`"></i>
              </div>
            </div>
          </label>

          <label for="your_pic">
            <div class="label_title">
              设定头像
            </div>
            <div class="pic_group">
              <div
                v-for="(p, j) in user_pic" :key="j"
                class="pic_item"
                :class="{'active': +j + 1 === +selectPicIndex}"
                :style="`background-image: url(${p.url})`"
                @click="selectPic(p)"></div>
            </div>
          </label>

          <div class="btn submit" :class="{'disabled': isDisabledSendInfoBtn}" @click="handleSendInfo">送出</div>
        </div>

        <div id="register__finish" :class="{'goIn': registerIndex === 3}">
          <img srcset="../../public/imgs/finish.png 1x, ../../public/imgs/finish.png 2x, ../../public/imgs/finish.png 3x" alt="">
          <div class="btn" @click="goNextUri">回首頁</div>
          <div class="btn govip" @click="goVip"><img src="../../public/imgs/ad_icon.png" style="width: 24px; margin: 0 8px 0 0;">开通VIP无广告</div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import BlockTitle from "@/components/BlockTitle.vue";

import {
  mapGetters,
  mapActions,
} from 'vuex';

export default {
  name: "register",
  components: {
    Header,
    BlockTitle
  },
  data() {
    return {
      step: [
        {id: 1, text: '填写帐号'},
        {id: 2, text: '设定暱称'},
        {id: 3, text: '完成'}
      ],
      user_pic: process.env.NODE_ENV === 'development' ? [
        { id: 1, url: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'},
        { id: 2, url: 'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'},
        { id: 3, url: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'},
        { id: 4, url: 'https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'},
        { id: 5, url: 'https://images.pexels.com/photos/1082962/pexels-photo-1082962.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'},
        { id: 6, url: 'https://images.pexels.com/photos/1043474/pexels-photo-1043474.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'},
      ] : window.avatar,

      isSubmit: false,
      minutes: '',
      seconds: '',

      account_id: '',
      nickname: '',
      password: '',
      checkPassword: '',
      selectPicIndex: 1,

      passwordType: 'password', // password, text
      passwordCheckType: 'password', // password, text

      redirect_uri: '',
      source: '',

      form: '',

      birthday_year: 1990,
      birthday_month: 1,
      birthday_day: 1,

      firstBirthYearTouch: true,
      firstBirthMonthTouch: true,
      firstBirthDayTouch: true
    }
  },
  watch: {
    registerIndex() {
      window.scrollTo(0, 0)
      if (this.registerIndex === 3) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },
  computed: {
    ...mapGetters([
      'loginUsernameError',
      'registerStep',
      'registerIndex',
      'registerError',
      'nextUri'
    ]),

    eyePasswordType() {
      switch (this.passwordType) {
        case 'password':
          return 'close'
          break;
        case 'text':
          return 'open'
          break;
      }
    },

    eyeCheckPasswordType() {
      switch (this.passwordCheckType) {
        case 'password':
          return 'close'
          break;
        case 'text':
          return 'open'
          break;
      }
    },

    isInValidAccountId() {
      if (this.account_id === '') {
        return
      }

      return !/^[a-zA-Z0-9._]{4,254}$/.test(this.account_id)
    },

    isInValidNickName() {
      if (this.nickname) {
        const max = 6 * 3
        const re = /[\w!'\(\)\*\-\.~]/; // 不會被編碼的字元
        let j = 0; // 不會被 encodeURIComponent 編碼的字元數 * 2
        let result = 0

        for(let i = 0; i < this.nickname.length; i++){
          if(re.test(this.nickname.charAt(i))){
            j += 2; // 計算有多少個字不會被編碼
          }
        }

        return max < (encodeURIComponent(this.nickname).length + j) / 3;
      }
    },

    isInValidBirthday() {
      return !(
        (this.birthday_year && +this.birthday_year > 0) &&
        (this.birthday_month && +this.birthday_month > 0) &&
        (this.birthday_day && +this.birthday_day > 0)
      )
    },

    isInValidPassword() {
      if (this.password) {
        return !/^(?=.*\d).{6,12}$/.test(this.password)
      }
    },

    isInValidCheckPassword() {
      if (this.checkPassword && this.password) {
        return !(this.checkPassword === this.password)
      }
    },

    isDisabledSendInfoBtn() {
      let result = true

      this.loginUsernameError === '' &&
      this.isInValidNickName === false &&
      this.isInValidPassword === false &&
      this.isInValidCheckPassword === false &&
      this.isInValidBirthday === false

      ? result = false
      : null

      return result
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)

    if (urlParams.get('redirect_uri')) {
      this.redirect_uri = urlParams.get('redirect_uri')
    }
  },
  methods: {
    ...mapActions([
      'validUsername',
      'registerByEmail',
      'registerInfo',
      'setRegisterStep',
      'setRegisterStepIndex',
      'resetRegisterError',
      'inputNewEmail'
    ]),

    selectPic(
      obj
    ) {
      const {
        id
      } = obj

      this.selectPicIndex = id
    },

    handleSeePassword(type) {
      if (type === 'checkpassword') {
        this.passwordCheckType === 'password'
        ? this.passwordCheckType = 'text'
        : this.passwordCheckType = 'password'
      } else {
        this.passwordType === 'password'
        ? this.passwordType = 'text'
        : this.passwordType = 'password'
      }
    },

    handleEmailSubmit() {
      if (this.isInValidAccountId) this.$refs.account_id.focus()

      if (this.isInValidAccountId === false) {
        let formData = new FormData();

        formData.append('account_id', this.account_id)
        formData.append('redirect_uri', this.redirect_uri)

        this.registerByEmail({
          formData
        })
      }
    },

    blurUsername() {
      let formData = new FormData()

      formData.append('username', this.nickname)

      this.validUsername({
        formData
      })
    },

    handleSendInfo() {
      if (
        this.isDisabledSendInfoBtn
      ) return

      const urlParams = new URLSearchParams(window.location.search)

      let formData = new FormData()

      formData.append('account_id', this.account_id)
      formData.append('username', this.nickname)
      formData.append('birthday', `${this.birthday_year}/${this.birthday_month}/${this.birthday_day}`)
      formData.append('password', this.password)
      formData.append('avatar', `avatar${this.selectPicIndex}`)
      formData.append('vid', urlParams.get('vid'))

      this.registerInfo({
        formData
      })
    },

    goNextUri() {
      window.location.href = this.nextUri
    },

    goVip() {
      window.location.href = this.nextUri + '/vip'
      gtag('event','VIP入口', {'event_category':'註冊第三步驟', 'send_to':'UA-137167386-5'});
    },

    clearBirthdayYearValue() {
      if (this.firstBirthYearTouch) {
        this.birthday_year = ''
        this.firstBirthYearTouch = false
      }
    },

    clearBirthdayMonthValue() {
      if (this.firstBirthMonthTouch) {
        this.birthday_month = ''
        this.firstBirthMonthTouch = false
      }
    },

    clearBirthdayDayValue() {
      if (this.firstBirthDayTouch) {
        this.birthday_day = ''
        this.firstBirthDayTouch = false
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.setRegisterStep({ stepName: 'register' })
    this.setRegisterStepIndex({ stepIndex: 1 })
    this.resetRegisterError()

    next()
  }
};
</script>
